var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AgentLite,{attrs:{"ai-permissions":_setup.AIPermissions}})
}
var staticRenderFns = []

export { render, staticRenderFns }